// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BubbleTitle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 2rem;
}
.BubbleTitle .BubbleTitle-Title {
  display: inline-block;
  background-color: #ebebeb;
  color: #000;
  text-align: center;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  font-weight: normal;
  border-radius: var(--bs-border-radius-pill);
}
.BubbleTitle .BubbleTitle-Subtitle {
  font-size: 1rem;
  text-align: center;
  font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/BubbleTitle/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AACF;AAAE;EACE,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;AAEJ;AAAE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AAEJ","sourcesContent":[".BubbleTitle {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  .BubbleTitle-Title {\n    display: inline-block;\n    background-color: #ebebeb;\n    color: #000;\n    text-align: center;\n    padding: 0.5rem 1rem;\n    font-size: 1.25rem;\n    font-weight: normal;\n    border-radius: var(--bs-border-radius-pill);\n  }\n  .BubbleTitle-Subtitle {\n    font-size: 1rem;\n    text-align: center;\n    font-weight: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
